// src/components/AccountCreation/Step3_PaymentDetails.js

import React, { useState, useEffect } from 'react';
import { callApi } from "../../lib/utils";
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Step3_PaymentDetails = ({ data, accessToken, checkoutDetails, initialPlanCode, isPendingFlow, isCancelledSubs, deviceInfo }) => {
  const [clientSecret, setClientSecret] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const currentPlanCode = data.subscription.tierPlanCode;
    const planHasChanged = initialPlanCode && initialPlanCode !== currentPlanCode;

    // 1. Check if checkoutDetails exist and the sessionStatus is 'open'
    if (!planHasChanged && checkoutDetails && checkoutDetails.sessionStatus === 'open' && checkoutDetails.sessionClientSecret) {
      console.log("Plan unchanged and session is open. Using existing client secret.");
      // If an open session exists, use its client secret directly
      setClientSecret(checkoutDetails.sessionClientSecret);
      // trackEvent('add_payment_info', {
      //   method: 'Stripe Embedded Checkout',
      //   plan_name: data.subscription.planName,
      //   price: data.subscription.price,
      // });


    } else {
      // 2. Otherwise, create a new checkout session as before
      console.log("Creating a new checkout session.");

      if (!data.subscription || !data.products) return;

      const subscriptionProduct = data.products.find(p => p.productType === 'SUBSCRIPTION');
      const activationFeeProduct = data.products.find(p => p.productType === 'ACTIVATION_FEE');

      const cartItems = [];
      if (subscriptionProduct) {
        cartItems.push({
          productId: subscriptionProduct.id,
          tierPlanCode: data.subscription.tierPlanCode,
          quantity: 1
        });
      }
      if (activationFeeProduct && !isCancelledSubs) {
        cartItems.push({
          productId: activationFeeProduct.id,
          quantity: 1
        });
      }

      const payload = {
        returnUrl: `${window.location.origin}/new/order/return`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cartItems: cartItems,
        pendingOrderId: checkoutDetails?.orderId,
        meta_data: {
          device_type: deviceInfo.device,
          os_type: deviceInfo.os
        }
      };

      let apiEndpoint = '';
      let headers; // Initialized as undefined

      if (isPendingFlow) {
        // --- EXISTING USER FLOW ---
        console.log("Using API for existing user (no headers).");
        apiEndpoint = '/api/orders/uportal/create-checkout-session';
        // headers remains undefined, so no header object will be sent with the API call.

      } else {
        // --- NEW USER FLOW ---
        console.log("Using API for new user.");
        apiEndpoint = '/api/public/orders/uportal/create-checkout-session';
        headers = { 'Authorization': `Bearer ${accessToken}` };
      }

      callApi(apiEndpoint, payload, 'POST', headers)
        .then(response => {
          if (response.data.success) {
            setClientSecret(response.data.data.clientSecret);
            // trackEvent('add_payment_info', {
            //   method: 'Stripe Embedded Checkout',
            //   plan_name: data.subscription.planName,
            //   price: data.subscription.price,
            // });

          } else {
            setError(response.data.message || "Failed to create checkout session.");
          }
        })
        .catch(err => {
          setError(err.message || "An error occurred. Please try again.");
        })
    }
  }, [data.subscription, data.products, accessToken, checkoutDetails]); // Add checkoutDetails to dependency array

  return (
    <div id="checkout">
      <h2 className="step-title text-center mb-4">Enter Payment Details</h2>
      {error ? (
        <p className="text-center text-danger">{error}</p>
      ) : clientSecret && stripePromise ? (
        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading payment form...</p>
        </div>
      )}
    </div>
  );
}

export default Step3_PaymentDetails;